import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import translationEN from "../public/il8n/en.json"
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { TermsComponent } from './components/terms/terms.component';
import { ApiService } from './services/api.service';
import { AppService } from './services/app.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, HeaderComponent, FooterComponent, TermsComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  imageBaseUrl:string = ''
  lazyLoading = true;
  $lazyLoading: Subscription;

  constructor(private translate:TranslateService, private apiService: ApiService, private appService: AppService) {
    this.$lazyLoading = this.apiService.$lazyLoading.subscribe(value => { this.lazyLoading = value; });
    this.translate.addLangs(['en']);
    this.translate.setTranslation("en", translationEN)
    this.translate.setDefaultLang('en');
    this.translate.use('en');

    this.imageBaseUrl = this.appService.ENV.IMAGE_BASE_URL
  }

  ngOnInit() {
    this.apiService.isAuthenticated().subscribe(() => {
      const hid = sessionStorage.getItem('lyt-auth-hid');
      if (hid) {
        this.apiService.memberPromotion(hid);
      }
      else {
        this.apiService.offer();
      }
    });
  }

  ngOnDestroy() {
    if (this.$lazyLoading) { this.$lazyLoading.unsubscribe(); }
  }

}
